import { useQuery } from '@tanstack/react-query';
import { employeesService } from '../services/employees.service';

export function useEmployee(id: string) {
  return useQuery({
    queryKey: ['employee', id],
    queryFn: () => employeesService.getEmployee(id),
    enabled: !!id,
  });
}
